import Navbar from "./components/Navbar/Navbar";
import Hero from "./sections/Hero/Hero";
import About from "./sections/About/About";
import Projects from "./sections/Projects/Projects";
import Contact from "./sections/Contact/Contact";
import Footer from "./components/Footer/Footer";
import { Analytics } from "@vercel/analytics/react";

import "./styles/global.css";

export default function App() {
  return (
    <div>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Analytics />

      <Navbar />

      <main id="main">
        <Hero />
        <About />
        <Projects />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}
